import Slider, { Settings } from "react-slick";
import { IoCodeSlash } from "react-icons/io5";
import guyWithLaptiop from "../Images/guy_with_laptop.png";
import penSvg from "../Images/pen.svg";
import { FiDatabase } from "react-icons/fi";
import cyberExperience from "../Images/cyberpack_experience.png";
import cbp01 from "../Images/development-frameworks.svg";
import cbp02 from "../Images/it-professionals.svg";
import cbp03 from "../Images/projects-completed.svg";
import { MarqueeComponent } from "../Components/MarqueeComponent";
import { OurProject } from "../Components/OurProject";
// import testLeft from "../Images/testimonial.png";
import { useNavigate } from "react-router-dom";
import * as routes from "../Data/Routes";
import Typewriter from "../Components/Typewritter";
import { IoIosArrowDropright } from "react-icons/io";
import { useEffect } from "react";
import { ScrollToSection } from "../HelperFunctions/Helpers";
import { ProjectEnquiry } from "./ProjectEnquiry";
// import { OurWork } from "./OurWork";

export const NewHome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Optional: smooth scrolling animation
      });
    };

    handleScrollToTop();
  }, []);

  const settings2: Settings = {
    rtl: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnFocus: true,
    pauseOnHover: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <div className="flex flex-col pt-[60px]">
      <section
        id="home"
        className="bg-[#1B1B22] font-italianax min-h-screen flex flex-col items-center justify-center px-4"
      >
        <div className="flex flex-col lg:flex-row items-center w-full max-w-[1200px] mx-auto mt-10 py-5">
          <div className="lg:w-1/2 mt-20 lg:mt-0 px-4">
            <div className="text-[#0FB8F9] text-[25px] font-normal text-center lg:text-left">
              WELCOME TO CYBERPACK
            </div>
            <div className="text-[20px] md:text-[35px] lg:text-[40px] xl:text-[55px] text-[#0FB8F9]  font-semibold leading-[100%] mt-8 mb-2 text-center lg:text-left">
              Pixel-Perfect <br className="md:hidden" />
              <span className="font-bold text-[#F5F5F5]">
                <Typewriter
                  toRotate={["Product.", "Design."]}
                  typingSpeed={100}
                  pauseBeforeDelete={5000}
                />
              </span>{" "}
              <br className="" />
              Bulletproof{" "}
              <span className="font-bold text-[#F5F5F5]">
                <Typewriter
                  toRotate={["Code."]}
                  typingSpeed={500}
                  pauseBeforeDelete={10000}
                />
              </span>
            </div>

            <div className="text-[#FAFAFA] text-base md:text-2xl leading-[150%] tracking-[0%] my-10 font-normal text-center lg:text-left mx-auto lg:mx-0">
              Your all-in-one team for digital product success.
            </div>

            <div className="w-fit mx-auto lg:mx-0">
              <button
                className="bg-[#0FB8F9] text-[#F5F5F5] text-xl px-6 py-2 rounded-[30px] mt-5 w-[244px]"
                onClick={() => {
                  ScrollToSection("project-enquiries");
                }}
              >
                Get Started
              </button>
            </div>
          </div>

          <div className="w-full min-[320px]:max-w-[200px] min-[425px]:max-w-[320px] md:max-w-[380px] h-auto flex-1 mt-10 lg:mt-0 mb-12 lg:mb-0 z-10 lg:ml-auto">
            <div className="relative aspect-square w-full min-[320px]:max-w-[200px] min-[425px]:max-w-[320px] md:max-w-[380px] mx-auto">
              <div className="border-2 border-dashed border-[#FFFFFF] rounded-full w-full h-full flex items-center justify-center">
                <div className="border border-[#817E7E] border-dashed rounded-full w-[85%] h-[85%] flex items-center justify-center">
                  <div className="bg-[#D9D9D9] rounded-full w-[85%] h-[85%] flex items-center justify-center overflow-hidden">
                    <img
                      src={guyWithLaptiop}
                      alt="guyWithLaptop"
                      className="object-cover"
                    />
                  </div>
                </div>
              </div>

              <div className="absolute inset-0 animate-spin-slow rounded-full w-[95%] md:w-full h-[95%] md:h-full my-auto mx-auto z-10 pointer-events-none">
                <div className="absolute left-[9%] top-[15%] transform -translate-x-1/2">
                  <div className="min-[320px]:size-[40px] min-[425px]:size-[57.76px] md:size-[67.76px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                    <IoCodeSlash className="text-[30px] text-white" />
                  </div>
                </div>

                <div className="absolute right-[3%] top-[20%] transform -translate-y-1/2">
                  <div className="min-[320px]:size-[40px] min-[425px]:size-[57.76px] md:size-[67.76px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                    <img
                      src={penSvg}
                      alt="pen icon"
                      className="w-[30px] h-[30px]"
                    />
                  </div>
                </div>

                <div className="absolute left-[25%] bottom-0 transform -translate-x-1/2">
                  <div className="min-[320px]:size-[40px] min-[425px]:size-[57.76px] md:size-[67.76px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                    <FiDatabase className="text-[30px] text-white" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#09A7E4] h-[500px] md:h-[720px] flex items-center justify-center flex-col font-italianax">
        <div className="text-xl md:text-[40px] text-[#F5F5F5] leading-[150%] tracking-[0%] font-medium text-center w-[90vw] md:w-[70vw] lg:w-[50vw]">
          Design-Driven Software, Engineered to Perform
        </div>
        <div className="text-white text-sm md:text-[25px] leading-[170%] tracking-[0%] font-normal text-center w-[90vw] md:w-[80vw] mt-16">
          We combine stunning design with rock-solid engineering to deliver
          world-class digital products. Whether you're launching an MVP, scaling
          a SaaS platform, or reimagining an existing app, our team of designers
          and developers will help you go from idea to launch and beyond. We
          don't just design interfaces or write code; we build end-to-end
          experiences that users love and businesses rely on.
        </div>
      </section>

      <section
        id="our-team"
        className="font-italianax h-[720px] md:h-[900px] lg:h-[720px] bg-[#1B1B22] px-[5vw] flex flex-col items-center justify-center relative overflow-hidden"
      >
        <div className="flex flex-col lg:flex-row items-center w-[95vw] lg:w-[65vw] z-[1]">
          <div className="flex flex-col lg:w-[50%]">
            <div className="flex items-center">
              <div className="size-[106px] bg-[#0FB8F9] rounded-[50%] flex items-center justify-center">
                <img src={cbp01} alt="cbp01" className="w-[55%]" />
              </div>
              <div className="ml-4">
                <div className="text-[#09A7E4] font-bold text-[30px] leading-[150%] tracking-[0%]">
                  21+
                </div>
                <div className="text-[#FFFFFF] font-normal text-base leading-[36px] tracking-[0%]">
                  Development Framework
                </div>
              </div>
            </div>

            <div className="flex items-center my-5">
              <div className="size-[106px] bg-[#0FB8F9] rounded-[50%] flex items-center justify-center">
                <img src={cbp02} alt="cbp02" className="w-[50%]" />
              </div>
              <div className="ml-4">
                <div className="text-[#09A7E4] font-bold text-[30px] leading-[150%] tracking-[0%]">
                  50+
                </div>
                <div className="text-[#FFFFFF] font-normal text-base leading-[36px] tracking-[0%]">
                  IT Professionals
                </div>
              </div>
            </div>

            <div className="flex items-center">
              <div className="size-[106px] bg-[#0FB8F9] rounded-[50%] flex items-center justify-center">
                <img src={cbp03} alt="cbp03" className="w-[55%]" />
              </div>
              <div className="ml-4">
                <div className="text-[#09A7E4] font-bold text-[30px] leading-[150%] tracking-[0%]">
                  100+
                </div>
                <div className="text-[#FFFFFF] font-normal text-base leading-[36px] tracking-[0%]">
                  Projects Completed
                </div>
              </div>
            </div>
          </div>

          <img
            src={cyberExperience}
            alt="cyberExperience"
            className="mt-10 lg:mt-0 w-[85%] md:w-[65%] lg:w-[50%] lg:ml-auto"
          />
        </div>
        <div className="border-[50px] md:border-[75px] lg:border-[100px] border-[#D9D9D9] opacity-5 absolute right-[-22vw] lg:right-[-10vw] bottom-[-16vw] lg:bottom-[-12vw] rounded-[50%] size-[65vw] lg:size-[40vw] z-[0]"></div>
      </section>

      <section
        id="our-services"
        className="lg:h-[120vh] bg-[#1B1B22] px-[5vw] flex flex-col lg:flex-row items-center justify-center font-manropex"
      >
        <div className="">
          <div className="h-[82px] flex items-center mt-20">
            <hr className=" rotate-180 bg-[#09A7E4] h-[42px] w-[6px] rounded-[50px]" />{" "}
            <div className="text-[#09A7E4] leading-[100%] tracking-[0%] ml-3">
              <span className="font-medium">OUR</span>
              <br />
              <span className="font-bold">SERVICES</span>
            </div>
          </div>
          <div className="text-[#F0FBFF] text-[20px] font-normal leading-[130%] tracking-[0%] lg:w-[276px]">
            We turn ideas into powerful digital products, built to perform,
            scale, and grow with your business.
          </div>
        </div>

        <div className="h-[455px] md:h-[585px] p-[25px] w-[90vw] md:w-[65vw] lg:w-[367px] mt-10 lg:mt-0 rounded-[30px] bg-[#2A2A2F] flex flex-col justify-center">
          <div className="flex items-center">
            <div className="size-[55px] md:size-[67.76px] bg-[#09A7E4] rounded-full flex items-center justify-center">
              <IoCodeSlash className="text-[30px] text-white" />
            </div>

            <div className="font-semibold text-xl md:text-[25px] leading-[100%] tracking-[0%] text-[#F0FBFF] ml-5">
              Software engineering
            </div>
          </div>

          <hr className="border-[#3D3D41] border-[1px] mt-5 mb-3" />

          <div className="text-[#F0FBFF] text-sm md:text-[20px] font-normal leading-[130%] tracking-[0%]">
            We don’t just write code, we engineer digital solutions that solve
            real-world problems. From startups to global enterprises, we help
            companies build robust, future-ready software that scales with their
            business. Whether you're launching a new product or upgrading your
            existing systems, we bring the technical depth, product thinking,
            and precision execution needed to bring your vision to life.
          </div>

          <hr className="border-[#3D3D41] border-[1px] mt-5 mb-3" />

          <button className="bg-[#0FB8F9] text-[#F5F5F5] px-6 h-[45px] md:h-[50px] rounded-[30px] mt-5 w-[180px] md:w-[211px] flex items-center justify-between">
            <div className="text-base md:text-xl leading-[36px] tracking-[0%]">
              More details
            </div>
            <div className="size-[30px] bg-[#EBEBEB] rounded-[50%] ml-2 flex items-center justify-center">
              <IoIosArrowDropright className="text-xl text-[#09A7E4]" />
            </div>
          </button>
        </div>

        <div className="h-[455px] md:h-[533px] p-[25px] w-[90vw] md:w-[65vw] lg:w-[367px] my-10 lg:my-0 rounded-[30px] bg-[#2A2A2F] lg:ml-[25px] flex flex-col justify-center">
          <div className="flex items-center">
            <div className="size-[55px] md:size-[67.76px] bg-[#09A7E4] rounded-full flex items-center justify-center">
              {/* <IoCodeSlash className="text-[30px] text-white" /> */}
              <img src={penSvg} alt="pen icon" className="w-[30px] h-[30px]" />
            </div>

            <div className="font-semibold text-xl md:text-[25px] leading-[100%] tracking-[0%] text-[#F0FBFF] ml-5">
              Product design
            </div>
          </div>

          <hr className="border-[#3D3D41] border-[1px] mt-5 mb-3" />

          <div className="text-[#F0FBFF] text-sm md:text-[20px] font-normal leading-[130%] tracking-[0%]">
            We specialize in crafting world-class UI/UX and product design
            experiences for startups, scale-ups, and enterprises ready to lead
            in the digital space. Whether you're building a product from scratch
            or looking to improve what already exists, we turn complex
            challenges into elegant, user-centered solutions that drive results.
          </div>

          <hr className="border-[#3D3D41] border-[1px] mt-5 mb-3" />

          <button
            onClick={() => {
              navigate(routes.productDesign);
            }}
            className="bg-[#0FB8F9] text-[#F5F5F5] px-6 h-[45px] md:h-[50px] rounded-[30px] mt-5 w-[180px] md:w-[211px] flex items-center justify-between"
          >
            <div className="text-base md:text-xl leading-[36px] tracking-[0%]">
              More details
            </div>
            <div className="size-[30px] bg-[#EBEBEB] rounded-[50%] ml-2 flex items-center justify-center">
              <IoIosArrowDropright className="text-xl text-[#09A7E4]" />
            </div>
          </button>
        </div>
      </section>

      {/* <OurWork /> */}
      <div className="flex items-center justify-center">
        <OurProject />
      </div>

      <section
        id="testimonial"
        className="h-[720px] bg-[#1B1B22] flex flex-col items-center font-helveticax"
      >
        <div className="w-full h-full flex flex-col items-center justify-center relative overflow-hidden lg:testimonial-bg">
          <div className="w-[90%] md:w-[60%] flex flex-col mx-auto">
            <div className="text-[#09A7E4] leading-[100%] tracking-[0%] text-[30px] text-center mt-5 mb-3">
              OUR <span className="font-bold">TESTIMONIALS</span>
            </div>
            <Slider {...settings2}>
              {[
                {
                  description:
                    "Comforting to have such a professional partner on call to help you. Creativity delivered what others couldn't; cost-effective and timely.",
                  name: "Joseph Thomas",
                  company: "Chairman, StormX",
                },
                {
                  description:
                    "From planning to deployment, WestPay showed a high level of expertise and commitment. The user experience and performance of the application have been excellent.",
                  name: "Samuel K",
                  company: "",
                },
                {
                  description:
                    "WestPay is reliable, detail-oriented, and very easy to work with. They handled a complex project professionally and delivered a secure, well-structured solution.",
                  name: "Aisha B",
                  company: "",
                },
                {
                  description:
                    "As someone without a strong technical background, I appreciated how WestPay explained every step clearly. The final product was clean, functional, and well thought out.",
                  name: "Daniel M",
                  company: "",
                },
              ].map((dt, index) => (
                <div
                  key={index}
                  className="h-[450px] flex flex-col items-center justify-center z-[5] text-[#FFFFFF]"
                >
                  <div className="my-[34px] h-[374px] rounded-tl-[50px] rounded-br-[50px] bg-[#2A2A2F] relative">
                    <div className="absolute top-[-14px] md:top-[-20px] left-[40px] md:left-[75px] flex gap-x-3">
                      <hr className="w-[18px] md:w-[25px] h-[35px] md:h-[51px] bg-[#09A7E4] skew-x-[30deg]" />
                      <hr className="w-[18px] md:w-[25px] h-[35px] md:h-[51px] bg-[#09A7E4] skew-x-[30deg]" />
                    </div>
                    <div className="absolute bottom-[-14px] md:bottom-[-20px] right-[40px] md:right-[75px] flex gap-x-3">
                      <hr className="w-[18px] md:w-[25px] h-[35px] md:h-[51px] bg-[#09A7E4] skew-x-[-30deg]" />
                      <hr className="w-[18px] md:w-[25px] h-[35px] md:h-[51px] bg-[#09A7E4] skew-x-[-30deg]" />
                    </div>
                    <div className="py-[40px] h-full flex flex-col">
                      <div className="w-[90%] md:w-[60%] mt-5 mx-auto text-[#FFFFFF] leading-[36px] tracking-[0%] text-xl font-normal text-center">
                        {dt.description}
                      </div>
                      <div className="text-[#FFFFFF] font-medium leading-[36px] tracking-[0%] text-xl text-center mt-8 md:mt-16">
                        {dt.name}
                      </div>
                      <div className="text-[#FFFFFF] font-normal leading-[36px] tracking-[0%] text-base text-center">
                        {dt.company}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      <div className="h-[320px] px-[5vw] bg-[#1B1B22] flex flex-col items-center justify-center">
        <div className="text-[#09A7E4] leading-[100%] tracking-[0%] text-[30px] text-center w-fit mb-5">
          OUR <span className="font-bold">CLIENTS</span>
        </div>
        <MarqueeComponent />
      </div>

      <ProjectEnquiry />
    </div>
  );
};
